import { TokenStats } from '@/pages/api/tokens/info';
import { useQuery } from '@tanstack/react-query';

import { normalizeTokenAddress } from '@/utils/normalizeAddress';
import { routes } from '@/utils/routes';

import { CoinGeckoCoinDataByTokenAddressResponse } from '../utils/coingecko/types';
import { fetcher } from '../utils/fetcher';

export type TokenInfo = {
  launchpad?: string;
  info: CoinGeckoCoinDataByTokenAddressResponse | undefined;
  stats: TokenStats | undefined;
};

const TOKEN_INFO_STALE_TIME = 5 * 60 * 1000;

export const tokenInfoQueryKey = (tokenAddress: string | undefined, chainId: number | undefined) =>
  [
    'token-info',
    tokenAddress && chainId ? normalizeTokenAddress(tokenAddress, chainId) : tokenAddress,
    chainId,
  ] as const;

export const useTokenInfo = (tokenAddress: string | undefined, chainId: number | undefined) => {
  const queryKey = tokenInfoQueryKey(tokenAddress, chainId);
  const [, normalizedAddress] = queryKey;

  return useQuery<TokenInfo, Error>({
    queryKey,
    queryFn: () =>
      fetcher(`${routes.api.TOKENS_INFO}?tokenAddress=${normalizedAddress}&chainId=${chainId}`),
    enabled: Boolean(tokenAddress && chainId),
    staleTime: TOKEN_INFO_STALE_TIME,
    refetchOnReconnect: false,
  });
};
